import React, {useEffect, useState} from "react";
import PropTypes, {InferProps} from "prop-types";
// eslint-disable-next-line @nrwl/nx/enforce-module-boundaries
import {useInvoice, usePersonView, usePrincipal, useStripe} from "@betrue/front/services";
import {Invoice, PaymentMode, StripePaymentDashboard} from "@betrue/shared/interfaces";
import {InvoiceListView} from "./invoice-list.view";
import {StripDashboardView} from "./stripe-dashboard.view";

export const InvoiceListPropsTypes = {
  loginLabel: PropTypes.string,
  invoiceRefLabel: PropTypes.string,
  amountUntaxeLabel: PropTypes.string,
  amountTotalLabel: PropTypes.string,
  creationDateLabel: PropTypes.string,
  fileLabel: PropTypes.string,
  removeLabel: PropTypes.string,
  payLabel: PropTypes.string,
  stateLabel: PropTypes.string,
  partnerLabel: PropTypes.string,
  source: PropTypes.string,
  paymentConfirmText: PropTypes.string,
  paymentDisagreeLabel: PropTypes.string,
  paymentAcceptLabel: PropTypes.string,
  totalInvoiceLabel: PropTypes.string,
  stripeBalanceLabel: PropTypes.string,
  stripPendingLabel: PropTypes.string,
  stripPayoutLabel: PropTypes.string,
  stripDashboard: PropTypes.string,
  invoiceSubmitter: PropTypes.string,
  paymentAcceptStripeSepaLabel: PropTypes.string,

}
export type InvoiceListProps = InferProps<typeof InvoiceListPropsTypes>

export const InvoiceList = (props: InvoiceListProps) => {
  const [principal] = usePrincipal()
  const [viewPerson,] = usePersonView()
  const [invoice, {paySupplierInvoice}] = useInvoice<Invoice>()
  const [userId, setUserId] = useState<string>(null)
  const [data, {dashboard, payout}] = useStripe<StripePaymentDashboard>()

  const [invoiceList, {supplierInvoices, deleteSupplierInvoice, findAll}] = useInvoice<Invoice[]>()

  useEffect(() => {
    if (viewPerson?.id && userId !== viewPerson.id) {
     setUserId(viewPerson.id)
    }
  }, [viewPerson])

  useEffect(() => {
    if (props.source === 'all') {
      findAll()
    }
  }, [userId])

  useEffect(() => {
    if (userId && props.source !== 'all') {
      dashboard(userId)
    }

  }, [userId])

  useEffect(() => {
    if (userId && props.source !== 'all') {
      supplierInvoices(userId)
    }

  }, [userId])


  const handleDeleteInvoice = (invoice: Invoice) => {
    deleteSupplierInvoice(invoice.id)
  }


  const handlePayout = (id: string) => {
    payout(id)
  }

  const handlePaySupplierInvoice = (invoice: Invoice, mode: PaymentMode) => {
    paySupplierInvoice(invoice.id, mode)
  }

  if (!invoiceList || !principal || !viewPerson) return (<></>)
  return (
    <>
      {viewPerson.stripeAccountId ? (<StripDashboardView data={data} onPayout={handlePayout}
                                                         total={(invoiceList.reduce((acc, curr) => {
                                                           return acc + curr.amountTotal
                                                         }, 0))}/>) : ('')}
      <InvoiceListView onPayInvoice={handlePaySupplierInvoice} currentUser={principal} invoices={invoiceList} {...props}
                       deleteInvoice={handleDeleteInvoice}/>
    </>
  );
}


InvoiceList.propTypes = InvoiceListPropsTypes
